import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/theme.css';

import { API_URLS, } from './helpers/api/API_URLS';
import { tokenParams } from './helpers/api/fetchParams';

import { getToken, testLoginExpires } from './data/serviceSso';

import { Navigation } from './component_nav/Navigation';
import ClientTool from './component_client/ClientTool';
import Promotions from './component_promotions/Promotions';
import Ecampaigns from './component_ecampaigns/Ecampaigns';
import CrmTool from './component_crmTest/CrmTool';
import Blogs from './component_blog/Blogs';
import { UptimeMonitor }  from './component_uptime/Uptime_Monitor';
import AllEndpoints from './component_endpoints/All_Endpoints';
import FlooringYouWell from './component_fyw/Flooring_You_Well';
// import Emser from './component_emser/Emser';

import * as serviceWorker from './serviceWorker';

import { getAllClients } from './data/serviceClients';
import { getSendGridTemplates } from './data/serviceSendgrid';
import NFA from './component_nfa/NfaTool';
import { hideMessage } from './helpers/uiFunctions/uiActions';

class Page extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoggedIn: false,
			roles: [],
			clients: [],
			sgTemplates: [],
		};
		this.loadClients = this.loadClients.bind(this);
		this.loadData = this.loadData.bind(this);
	}
	componentDidMount() {
		var isExpired = testLoginExpires();
		if (isExpired) {
			//console.log("expired")
			this.loggout();
		} else {
			//console.log("not expired")
			this.setState({
				roles: localStorage.getItem("roles"),
				isLoggedIn: true,
			});
			this.initiatePage();
		}
		setInterval(() => {
			// test expires every 10 seconds, loggout session if isExpired === true
			isExpired = testLoginExpires();
			if(isExpired) { this.loggout(); /*console.log("interval expired")*/ }
			else { /*silence is golden*/ }
		}, 10000);
	}

// LOGIN / SYSTEM ---------------------------------------------------------------------------------------
	async loggin() {
		let user = document.getElementById("username").value;
		let pass = document.getElementById("password").value;
		var params = tokenParams(user, pass);

		await getToken(params).then(data => {
			console.log("logged in");
			console.log(data);
			if (data[0] === false) {
				document.querySelector('#login-error').innerHTML = "<small><em>The Email or Password you entered is incorrect.</br>Please check and try again.</em></small>"
				return false;
			} else {
				this.setState({
					roles: data[1],
					name: data[2],
					isLoggedIn: true,
				})
			}
		}).then(() => {
			this.initiatePage();
		})
	}
	loggout() {
		this.setState({ isLoggedIn: false, roles: [], clients: [], sgTemplates: [] });
		localStorage.clear();
	}
	showReset() {
		var login = document.getElementById("logginForm");
		var pass = document.getElementById("forgotPass");
		if (login.style.display === "none") {
			login.style.display = "block";
			pass.style.display = "none";
		} else {
			login.style.display = "none";
			pass.style.display = "block";
		}
	}
	passReset() {
		console.log("reset the pass");
		var user = document.getElementById("forgotUsername").value;
		if (user) {
			fetch(API_URLS.sso+"forgot/"+user, {method: "POST"})
			.then(response => {
				if (response.ok) { return response.text(); }
				else { throw new Error('Something went wrong ...'); }
			})
			.then(data => {
				console.log(data);
				document.getElementById("logginForm").style.display = "block";
				document.getElementById("forgotPass").style.display = "none";
				document.getElementById("reset-error").innerHTML = "";
				document.getElementById("forgotUsername").value = "";
			})
			.catch(error => {
				console.log(error);
				document.getElementById("reset-error").innerHTML = "Username invalid";
			});
		} else {
			document.getElementById("reset-error").innerHTML = "Need to give a username";
		}
	}


// DATA ---------------------------------------------------------------------------------------
	async initiatePage() {
		console.log("initiate page loading");
		this.loadClients();
		this.loadData();
	}	
	async loadData() {
		await getSendGridTemplates().then(templates => {
			this.setState({
				sgTemplates: templates
			})
		});
	}
	async loadClients() {
		await getAllClients().then(clientArr => {
			this.setState({
				clients: clientArr.filter( client => { return client.type === "client"; })
			})
		});
	}

	render() {
		const {
			isLoggedIn, roles,
			clients, sgTemplates
		} = this.state;
		return (
			(roles !== []) && (
			<div>
				<header id="header">
	            	<div>
	                	<h1>C.D.E.</h1>
	                </div>
	                { isLoggedIn ? (
	                	<Navigation loggout={() => this.loggout()} />
                    ) : (
                    	<div id="top-nav">
	                    	<div id="admin-bar">
			                	<span>Your session has expired</span>
			                </div>
		                </div>
                    )}
					<div id={"status-message"} className="status-message">
						<span className="copy"></span>
						<span className="action">
							<button className="button close" onClick={() => hideMessage("close") }>X</button>
						</span>
					</div>
	            </header>
				{ isLoggedIn ? (
					<div>
						{(roles.includes("clients") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="client" className="col client active">
								<ClientTool clients={clients} loadClients={this.loadClients} />
							</div>
                		)}
                		{(roles.includes("promos") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="promotions" className="col promotions">
					        	<Promotions
					        		clients={clients}
					        		sgTemplates={sgTemplates}
					        	/>
					        </div>
                		)}
                		{(roles.includes("ecamps") || roles.includes("admin")) && (
                			<div id="ecampaigns" className="col ecampaigns">
					        	<Ecampaigns
					        		clients={clients}
					        		sgTemplates={sgTemplates}
					        	/>
					        </div>
                		)}
                		{(roles.includes("crmtest") || roles.includes("admin") || roles.includes("manager")) && (
                			<CrmTool
								clients={clients}
								sgTemplates={sgTemplates}
							/>
                		)}
                		{(roles.includes("blog") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="blogs" className="col blog">
					        	<Blogs clients={clients.filter( client => { return client.status === "active"; })} />
					        </div>
                		)}
                		{(roles.includes("uptime") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="uptime" className="col uptime">
					        	<UptimeMonitor roles={roles} />
					        </div>
                		)}
                		{(roles.includes("endpts") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="endpoints" className="col endpoints">
					        	<AllEndpoints />
					        </div>
                		)}
                		{(roles.includes("fyw") || roles.includes("admin")) && (
                			<div id="flooring-you-well" className="col flooring-you-well">
					        	<FlooringYouWell />
					        </div>
                		)}
						{(roles.includes("nfa") || roles.includes("admin") || roles.includes("manager")) && (
                			<div id="nfa" className="col nfa">
					        	<NFA />
					        </div>
                		)}
                		{/* {(roles.includes("dev")) && (
                			<div id="emser" className="col emser">
					        	<Emser />
					        </div>
                		)} */}
					</div>
				) : (
					<div id="loggin" className="col loggin">
						<section className="input-group">
			                <form className="form loggin-form" id="logginForm">
								<h3>Log In</h3>
								<div className="input-row">
									<label>User Name</label>
									<input type="text" className="input" id="username" placeholder="User Name" />
								</div>
								<div className="input-row">
									<label>Password</label>
									<input type="password" className="input" id="password" placeholder="Password" />
								</div>
								<p id="login-error"></p>
								<input type="button" className="button is-info" onClick={() => this.loggin()} value="Log In" />
								<p className="forgot-link" onClick={() => this.showReset()}>forgot password</p>
							</form>
			            </section>
			            <section className="input-group">
			            	<form className="form forgot-pass" id="forgotPass" style={{display: "none"}}>
			            		<h3>Forgot My Password</h3>
			            		<div className="input-row">
									<label>User Name</label>
									<input type="text" className="input" id="forgotUsername" placeholder="User Name" />
								</div>
								<p id="reset-error"></p>
								<input type="button" className="button is-info" onClick={() => this.passReset()} value="Send New Password" />
								<p className="forgot-link" onClick={() => this.showReset()}>Back To Login</p>
			            	</form>
			            </section>
					</div>
				) }
			</div>
			)
		)
	}
}

ReactDOM.render(<Page />, document.getElementById('main'));
// ReactDOM.render(<Header />, document.getElementById('header'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js